<template>
    <div class="w-full h-screen flex flex-col justify-between" :class="'theme-'+theme">
        <div class="mx-auto max-w-2xl py-[80px] flex flex-col items-center">
            <Head title="Avregistrera dig från påminnelser" />

            <div v-if="theme === 'purple'">
                <img src="/img/eliquis-logo.png" alt="Eliquis" class="max-w-[274px]">
            </div>
            <div v-else>
                <img src="https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/795857_779661/Pfizer-Logo.png" alt="Pfizer" class="max-w-[274px]">
            </div>

            <div v-if="success">
                <h2 class="text-2xl font-bold mt-8 mb-2">Avregistrering bekräftad!</h2>
                <p>Du kommer inte få fler påminnelsemail från vår webbshop.</p>
                <p class="mt-8">Var det inte meningen att avregistrera? <Link @click="resubscribe" :class="theme">Klicka här för att prenumerera på påminnelsemail</Link></p>
            </div>
            <h2 v-else class="text-2xl font-bold mt-8 mb-2">Kunde inte hitta någon användare med denna e-postadress</h2>
        </div>
        <EliquisFooterBlock v-if="theme === 'purple'" />
    </div>
    
</template>

<script>
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import EliquisFooterBlock from '@/Shared/EliquisFooterBlock.vue'

    export default {
        components: {
            Head,
            EliquisFooterBlock,
            Link,
        },
        props: {
            success: Boolean,
            hashedOrderId: String,
            theme: String,
        },
        methods: {
            resubscribe() {
                this.$inertia.get('/resubscribe-to-order-reminders/'+this.hashedOrderId);
            },
        },
    }
</script>
<style scoped>
.theme-purple {
    background-color: white;
}

a.purple {
    color: rgb(130, 18, 87)
}

a.blue {
    color: rgb(0, 0, 201)
}

</style>